// Lightweight client-side login gate for this frontend-only (localStorage) app.
// Credentials come from env (REACT_APP_LOGIN_USERS comma-list, REACT_APP_LOGIN_PASS).
// Note: this is a simple access gate, not server-side security — appropriate for a
// non-sensitive satsang schedule tool with no backend/database.
const KEY = "rssb_session_v1";

const allowedUsers = (process.env.REACT_APP_LOGIN_USERS || "")
  .split(",")
  .map((u) => u.trim().toLowerCase())
  .filter(Boolean);
const allowedPass = process.env.REACT_APP_LOGIN_PASS || "";

export const isAuthed = () => localStorage.getItem(KEY) === "ok";

export const login = (userId, password) => {
  const u = (userId || "").trim().toLowerCase();
  if (allowedUsers.includes(u) && (password || "").trim() === allowedPass) {
    localStorage.setItem(KEY, "ok");
    return true;
  }
  return false;
};

export const logout = () => {
  localStorage.removeItem(KEY);
  window.location.reload();
};
